import {Injectable} from "@angular/core";
import {AuthApiService} from "../auth/auth-api.service";
import {AppPaymentAccountData} from "./app-payment-account.data";
import {AppPaymentAccountCreateRequestData} from "./app-payment-account-create-request.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class AppPaymentAccountService {

    constructor(private http: HttpClient, private auth: AuthApiService) {
    }

    async generateAppPaymentAccountUrl(venueId: string): Promise<string> {
        return firstValueFrom(this.http.get("/fonzie/customer-instance-venue/" + venueId + "/generate-app-payment-account-url", {
            headers: this.auth.getHttpHeaderOptions(),
            responseType: "text"
        }));
    }

    async getAppPaymentAccount(token: string): Promise<AppPaymentAccountData> {
        this.auth.signInUsingSignUpToken(token);
        return firstValueFrom(this.http.get<AppPaymentAccountData>("/fonzie/app-payment-account", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createAppPaymentAccount(appPaymentAccountCreateRequestData: AppPaymentAccountCreateRequestData): Promise<AppPaymentAccountData> {
        return firstValueFrom(this.http.post<AppPaymentAccountData>("/fonzie/app-payment-account", appPaymentAccountCreateRequestData, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async sendSetupUrl(venueId: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/send-app-payment-account-url", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
